import { render, staticRenderFns } from "./modalClose.vue?vue&type=template&id=c096523e&"
import script from "./modalClose.vue?vue&type=script&lang=js&"
export * from "./modalClose.vue?vue&type=script&lang=js&"
import style0 from "./modalClose.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports